import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const ClientFilters = ({ language, filters, onFilterChange, onReset }) => {
  const statusOptions = [
    { value: 'all', label: language === 'ar' ? 'الكل' : language === 'fr' ? 'Tous' : 'All' },
    { value: 'active', label: language === 'ar' ? 'نشط' : language === 'fr' ? 'Actif' : 'Active' },
    { value: 'inactive', label: language === 'ar' ? 'غير نشط' : language === 'fr' ? 'Inactif' : 'Inactive' },
    { value: 'pending', label: language === 'ar' ? 'قيد الانتظار' : language === 'fr' ? 'En attente' : 'Pending' }
  ];

  const practiceAreaOptions = [
    { value: 'all', label: language === 'ar' ? 'الكل' : language === 'fr' ? 'Tous' : 'All' },
    { value: 'civil', label: language === 'ar' ? 'القانون المدني' : language === 'fr' ? 'Droit civil' : 'Civil Law' },
    { value: 'criminal', label: language === 'ar' ? 'القانون الجنائي' : language === 'fr' ? 'Droit pénal' : 'Criminal Law' },
    { value: 'commercial', label: language === 'ar' ? 'القانون التجاري' : language === 'fr' ? 'Droit commercial' : 'Commercial Law' },
    { value: 'family', label: language === 'ar' ? 'قانون الأسرة' : language === 'fr' ? 'Droit de la famille' : 'Family Law' },
    { value: 'labor', label: language === 'ar' ? 'قانون العمل' : language === 'fr' ? 'Droit du travail' : 'Labor Law' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-4 md:mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label={language === 'ar' ? 'الحالة' : language === 'fr' ? 'Statut' : 'Status'}
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label={language === 'ar' ? 'مجال الممارسة' : language === 'fr' ? 'Domaine de pratique' : 'Practice Area'}
          options={practiceAreaOptions}
          value={filters?.practiceArea}
          onChange={(value) => onFilterChange('practiceArea', value)}
        />

        <Input
          type="date"
          label={language === 'ar' ? 'من تاريخ' : language === 'fr' ? 'Date de début' : 'From Date'}
          value={filters?.dateFrom}
          onChange={(e) => onFilterChange('dateFrom', e?.target?.value)}
        />

        <Input
          type="date"
          label={language === 'ar' ? 'إلى تاريخ' : language === 'fr' ? 'Date de fin' : 'To Date'}
          value={filters?.dateTo}
          onChange={(e) => onFilterChange('dateTo', e?.target?.value)}
        />
      </div>
      <div className="flex justify-end mt-4">
        <Button
          variant="outline"
          size="sm"
          onClick={onReset}
          iconName="RotateCcw"
          iconPosition="left"
          iconSize={14}
        >
          {language === 'ar' ? 'إعادة تعيين' : language === 'fr' ? 'Réinitialiser' : 'Reset'}
        </Button>
      </div>
    </div>
  );
};

export default ClientFilters;